import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';

const AudioPlayerModal = ({ details, modalOpen, handleClose }) => {
  const audioRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [audioUrl, setAudioUrl] = useState(null);

  useEffect(() => {
    const abortController = new AbortController();

    const fetchAudio = async () => {
      if (modalOpen && details?.src) {
        setIsLoading(true);
        setAudioUrl(null);

        try {
          const response = await fetch(details.src, { signal: abortController.signal });
          const blob = await response.blob();
          const url = URL.createObjectURL(blob);
          setAudioUrl(url);
          setIsLoading(false);
        } catch (error) {
          console.error('Audio fetch failed:', error);
          setIsLoading(false);
        }
      }
    };

    fetchAudio();

    return () => {
      abortController.abort();
      setAudioUrl(null);
      setIsLoading(true);
    };
  }, [modalOpen, details]);

  const handleCloseModal = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
    }
    if (audioUrl) {
      URL.revokeObjectURL(audioUrl); // cleanup
    }
    setAudioUrl(null);
    setIsLoading(true);
    handleClose();
  };

  return (
    <Modal isOpen={modalOpen} size="md" centered backdrop>
      <ModalHeader className="d-flex justify-content-center">Recording</ModalHeader>
      <ModalBody>
        {isLoading && (
          <div className="d-flex justify-content-center mb-3">
            <Spinner color="primary" />
          </div>
        )}

        {audioUrl && !isLoading && (
          <audio ref={audioRef} src={audioUrl} controls style={{ width: '100%' }} />
        )}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        <Button color="danger" className="px-5" onClick={handleCloseModal}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

AudioPlayerModal.propTypes = {
  modalOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  details: PropTypes.shape({
    src: PropTypes.string.isRequired
  }).isRequired
};

export default AudioPlayerModal;
